<router-outlet></router-outlet>

<app-flash-message-outlet></app-flash-message-outlet>
